import {RootState} from '../../utils/types';

export const companySelector = (state: RootState) => state.company.map;
export const companyStatusSelector = (state: RootState) => state.company.status
// export const getCompanyWithId = (state: RootState) 
export const companyInfoSelector = (state: RootState) => state.company